import { composeIO } from 'react-compose-io'
import { customDrawerIO } from './CustomDrawer.IO'
import { CustomDrawerView } from './CustomDrawer.View'

export const CustomDrawer = composeIO(CustomDrawerView, customDrawerIO)
